import { UserWorkLog } from '../../../types/apiDomain';
import EditMode from '../types/EditMode';
import { ColumnProps } from 'antd/lib/table';
import { Button, Dropdown, Menu } from 'antd';
import classNames from 'classnames';
import styles from '../MyActivitiesPage.module.css';
import Text from 'antd/lib/typography/Text';
import moment from 'moment';
import { minutesToHours } from '../../../utils/timeConversion';
import React from 'react';

const createTableColumns = (
    handleEdit: (record: UserWorkLog) => void,
    editMode: EditMode,
    handleDelete: (record: UserWorkLog) => void
): ColumnProps<UserWorkLog>[] => {
    const isEditMode = editMode === EditMode.EDIT;

    return [
        {
            title: 'Issue ID',
            dataIndex: 'displayableIssueId',
            key: 'displayableIssueId',
            render: (text, record) => {
                const { displayableIssueId, issueUrl, isFromCurrentImportRange, isEditable } = record;

                const baseElement = isEditable ? (
                    <Button
                        type="link"
                        className={classNames(styles.linkButton, { [styles.cursorDefault]: isEditMode })}
                        onClick={() => handleEdit(record)}
                    >
                        {displayableIssueId}
                    </Button>
                ) : (
                    <a href={issueUrl ?? undefined} target="_blank" rel="noopener noreferrer">
                        {displayableIssueId}
                    </a>
                );

                const canBeDeleted = isFromCurrentImportRange; // || isInternal;

                if (canBeDeleted) {
                    const menu = (
                        <Menu>
                            {canBeDeleted && (
                                <Menu.Item onClick={() => handleDelete(record)}>
                                    <Text type="danger">Удалить</Text>
                                </Menu.Item>
                            )}
                        </Menu>
                    );

                    return <Dropdown overlay={menu}>{baseElement}</Dropdown>;
                }

                return baseElement;
            },
            className: styles.textNoWrap,
            sorter: (a, b) => a.displayableIssueId.localeCompare(b.displayableIssueId)
        },
        {
            title: 'Дата',
            dataIndex: 'date',
            key: 'date',
            className: styles.textNoWrap,
            sorter: (a, b) => moment(a.date).diff(b.date)
        },
        {
            title: 'Проект',
            dataIndex: 'project',
            key: 'project',
            sorter: (a, b) => a.project.localeCompare(b.project)
        },
        {
            title: 'Время',
            dataIndex: 'amount',
            key: 'amount',
            render: (text, { minutes }) => minutesToHours(minutes),
            sorter: (a, b) => a.minutes - b.minutes
        },
        {
            title: 'Комментарий',
            dataIndex: 'comment',
            key: 'comment',
            className: styles.textPreWrap
        }
    ];
};

export default createTableColumns;
